import { Stage } from 'konva/lib/Stage';
import { useMapCanvasStage } from '../contexts/MapCanvasContext';
import { getWindowKonvaObject } from './konva/getWindowKonvaObject';

export function useZoomStageToScale() {
  const { stagePositionRef, updateStagePosition } = useMapCanvasStage();

  return (stage: Stage, newScale: number, animate = false) => {
    if (!stage) return;

    const stagePosition = stagePositionRef.current;
    const stageWidth = stage.width();
    const stageHeight = stage.height();
    const centerX = stageWidth / 2;
    const centerY = stageHeight / 2;
    const pointTo = {
      x: (centerX - stagePosition.x) / stagePosition.scale,
      y: (centerY - stagePosition.y) / stagePosition.scale
    };

    stage.to({
      duration: animate ? 0.3 : 0,
      easing: animate ? getWindowKonvaObject().Easings.EaseInOut : undefined,
      scaleX: newScale,
      scaleY: newScale,
      x: centerX - pointTo.x * newScale,
      y: centerY - pointTo.y * newScale,
      onFinish: () => {
        updateStagePosition({
          scale: newScale,
          x: centerX - pointTo.x * newScale,
          y: centerY - pointTo.y * newScale
        });
      }
    });
  };
}
